import apiClient from '@/services/api-client';

export const sendAssistantMessage = async (payload) => {
  if (payload.files && payload.files.length) {
    const formData = new FormData();
    formData.append('message', payload.message || '');
    if (payload.conversationId) {
      formData.append('conversationId', payload.conversationId);
    }
    if (payload.confirmed !== undefined) {
      formData.append('confirmed', payload.confirmed);
    }
    if (payload.confirmedToolName) {
      formData.append('confirmedToolName', payload.confirmedToolName);
    }
    if (payload.confirmedArguments) {
      formData.append('confirmedArguments', JSON.stringify(payload.confirmedArguments));
    }
    payload.files.forEach((file) => formData.append('files', file));

    const response = await apiClient.post('/assistant/chat', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  const response = await apiClient.post('/assistant/chat', payload);
  return response.data;
};
